var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8.75109V8.74625C21 8.48103 20.8946 8.22668 20.7071 8.03914L12.8009 0.132891C12.6133 -0.0546452 12.359 -0.160002 12.0937 -0.160002L12.0831 -0.160002C12.0818 -0.160004 12.0806 -0.160004 12.0793 -0.160002L5 -0.160002C3.89543 -0.160002 3 0.73543 3 1.84V21.84C3 22.9446 3.89543 23.84 5 23.84H19C20.1046 23.84 21 22.9446 21 21.84V8.76694C21 8.76165 21 8.75637 21 8.75109ZM10.9999 1.84L10.9999 8.75879C10.9999 9.02401 11.1053 9.27836 11.2928 9.4659C11.4804 9.65343 11.7347 9.75879 11.9999 9.75879H19V21.84H5V1.84L10.9999 1.84ZM12.9999 3.17294L12.9999 7.75879L17.5858 7.75879L12.9999 3.17294Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_1505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.b0d9c56daa3032c0558ed38ccdfc289b.svg";
export { ForwardRef as ReactComponent };